Alpine.data('addonForm', (props) => ({

    loading: false,
    errors: {},
    grandTotal: 0,
    subscription: props.subscription,
    showForm: false,
    symbol: props.symbol,
    adonForm: null,
    startDate: null,
    endDate: null,
    billingType: null,
    paymentMethods: props.paymentMethods,

    items: props.items,

    updatePerPrices(plan = {}) {
        if (!Array.isArray(this.items) || this.items.length === 0) return;

        const priceMap = {
            extra_listing: plan.extra_listing_price,
            gold: plan.price_per_gold,
            silver: plan.price_per_silver,
            featured: plan.price_per_featured_listings,
        };

        this.items = this.items.map((row) => ({
            ...row,
            price: priceMap[row.addon_type] ?? row.price,
        }));
    },

    loadSubscriptionData(subscription) {
        if (!subscription) return;

        const plan = subscription.plan_snapshot || {};

        this.startDate = subscription.current_period_start || '';
        this.endDate = subscription.current_period_end || '';

        this.updatePerPrices(plan);
        this.calculate();
        this.billingType = '';
    },

    resetForm(event) {
        const detail = event.detail || {};

        this.items = detail.items || [];
        this.updatePerPrices(detail.subscription?.plan_snapshot || {});
        this.calculate();
        this.billingType = '';
    },

    init() {
        this.loadSubscriptionData(this.subscription);

        window.addEventListener('resetAdonForm', this.resetForm.bind(this));
    },

    currency(value) {
        return this.symbol + '' + parseFloat(value).toFixed(2);
    },
    get totalMonths() {

        // Using Moment.js
        const start = moment(this.startDate);
        const end = moment(this.endDate);

        return end.diff(start, 'months', true).toFixed(2);
    },

    calculate() {
        this.grandTotal = 0;
        // There is subsctipition
        // _self.subscription


        const startDate = this.subscription.current_period_start;
        const endDate = this.subscription.current_period_end;

        // Using Moment.js
        const start = moment(startDate);
        const end = moment(endDate);

        const totalMonths = end.diff(start, 'months', true);
        if (this.items && this.items.length > 0) {
            this.grandTotal = 0;

            this.items.forEach(item => {
                const subtotal = item.quantity * item.price * totalMonths;
                const taxAmount = subtotal * 0.05; // 5% tax

                item.tax = taxAmount.toFixed(2);
                item.total = (subtotal + taxAmount).toFixed(2);

                this.grandTotal += parseFloat(item.total);
            });

            this.grandTotal = this.grandTotal;
        }
    },

    resetRow(index) {
        this.items[index].quantity = 0;
        this.calculate();
    },


    async submitForm() {
        this.errors = [];
        if (!this.grandTotal) {
            this.$refs.qty.focus();
            this.errors['quantity'] = 'At least one addon quantity must be greater than 0.';
            return;
        }

        this.calculate();

        Livewire.emit('confirmSubmitForm', { items: this.items, total: this.grandTotal, totalMonths: this.totalMonths });
        return;

        this.loading = true;

        // let payload = {
        //     billing_type: 'one_time',
        //     starts_at: '2026-04-13',
        //     ends_at: '2026-05-13',
        //     grand_total: this.grandTotal,
        //     items: this.items
        // };

        // try {

        //     let response = await fetch('/addons/store', {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'X-CSRF-TOKEN': document
        //                 .querySelector('meta[name="csrf-token"]')
        //                 ?.content
        //         },
        //         body: JSON.stringify(payload)
        //     });

        //     let data = await response.json();

        //     alert(data.message || 'Saved Successfully');

        // } catch (error) {
        //     alert('Something went wrong.');
        // }

        this.loading = false;
    }

}));